export const QUERY_KEY_PRODUCTS_USER_ACTIVITY_SUMMARY =
  'QUERY_KEY_PRODUCTS_USER_ACTIVITY_SUMMARY'

export const MUTATION_KEY_PRODUCTS_USER_ACTIVITY_REJECT_TASK =
  'MUTATION_KEY_PRODUCTS_USER_ACTIVITY_REJECT_TASK'

export const QUERY_KEY_PRODUCT_ACTIVITY_ITEMS =
  'QUERY_KEY_PRODUCT_ACTIVITY_ITEMS'
